"use client"

import { ErrorDisplay } from "@repo/ui"

interface ErrorProps {
	error: Error & { digest?: string }
	reset: () => void
}

/**
 * 错误边界组件
 * @param error - 错误对象，包含错误信息和可选的 digest
 * @param reset - 重置函数，用于尝试重新渲染组件树
 */
export default function Error({ error, reset }: ErrorProps) {
	return (
		<>
			<ErrorDisplay error={error} />
		</>
	)
}
